var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoneyMousePink = function SvgMoneyMousePink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "money-mouse--pink_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".money-mouse--pink_svg__st0{fill:#f68dfe}.money-mouse--pink_svg__st1{fill:#fff}.money-mouse--pink_svg__st2{fill:#0b1b34}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 52h46.4V28H16.8v24z",
    className: "money-mouse--pink_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2 52.8H16.8c-.5 0-.8-.3-.8-.8V28c0-.5.3-.8.8-.8h46.4c.5 0 .8.3.8.8v24c0 .5-.3.8-.8.8zm-45.6-1.6h44.8V28.8H17.6v22.4z",
    className: "money-mouse--pink_svg__st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2 48.8c0-1.8 1.4-3.2 3.2-3.2V34.4c-1.8 0-3.2-1.4-3.2-3.2H23.8c0 1.8-1.4 3.2-3.2 3.2v11.2c1.8 0 3.2 1.4 3.2 3.2h32.4z",
    className: "money-mouse--pink_svg__st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2 49.6H23v-.8c0-1.4-1-2.4-2.4-2.4h-.8V33.6h.8c1.4 0 2.4-1 2.4-2.4v-.8h34.2v.8c0 1.3 1 2.4 2.4 2.4h.8v12.8h-.8c-1.4 0-2.4 1-2.4 2.4v.8h-1zM24.5 48h31.1c.3-1.6 1.5-2.8 3.1-3.1v-9.8c-1.6-.3-2.8-1.5-3.1-3.1H24.5c-.3 1.5-1.5 2.8-3.1 3.1v9.8c1.5.3 2.8 1.5 3.1 3.1z",
    className: "money-mouse--pink_svg__st1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 45.2c2.7 0 4.8-2.1 4.8-4.8 0-2.7-2.1-4.8-4.8-4.8-2.7 0-4.8 2.1-4.8 4.8 0 2.7 2.1 4.8 4.8 4.8z",
    className: "money-mouse--pink_svg__st0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 46c-3.1 0-5.6-2.6-5.6-5.6 0-3 2.6-5.6 5.6-5.6s5.6 2.6 5.6 5.6c0 3-2.5 5.6-5.6 5.6zm0-9.7c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zM60.7 48.3l-1.1 1.1 8.2 8.2 1.1-1.1-8.2-8.2z",
    className: "money-mouse--pink_svg__st1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m61.5 47.4-2.8 2.8 8.2 8.2 2.8-2.8-8.2-8.2z",
    className: "money-mouse--pink_svg__st2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9 59.2c-.2 0-.4-.1-.6-.2l-8.2-8.2c-.3-.3-.3-.8 0-1.1l2.8-2.8c.2-.2.3-.2.6-.2.2 0 .4.1.6.2l8.2 8.2c.3.3.3.8 0 1.1L67.4 59c-.1.1-.4.2-.5.2zm-7.1-9 7 7 1.7-1.7-7-7-1.7 1.7z",
    className: "money-mouse--pink_svg__st1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m70.3 48.7-8 2.3-2.3 8-7.1-17.4 17.4 7.1z",
    className: "money-mouse--pink_svg__st2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60 59.8c-.3 0-.6-.2-.7-.5l-7.1-17.4c-.2-.3-.1-.6.2-.9.2-.2.6-.3.9-.2L70.6 48c.3.2.5.5.5.8s-.2.6-.6.7L63 51.7l-2.2 7.5c-.1.3-.4.6-.8.6 0 0 .1 0 0 0zM54.3 43l5.5 13.5 1.7-5.8c.1-.2.3-.5.6-.6l5.8-1.7L54.3 43z",
    className: "money-mouse--pink_svg__st1"
  })));
};
export default SvgMoneyMousePink;